module.exports = __webpack_public_path__ + "img/share2.6d8b6b00.png";